<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
    <el-form-item label="账号" prop="username">
      {{ ruleForm.username }}
    </el-form-item>
    <el-form-item v-if="!bind" label="密码" prop="password">
      <el-input
          clearable
          show-password
          type="password"
          v-model.trim="ruleForm.password"
          placeholder="请输入密码"
      ></el-input>
    </el-form-item>
    <el-form-item label="学校" prop="college">
      {{ ruleForm.college }}
    </el-form-item>
    <el-form-item v-if="!bind" label="学/工号" prop="workNo">
      <el-input v-model="ruleForm.workNo" placeholder="请输入学/工号" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="真实姓名" prop="realname">
      {{ ruleForm.realname }}
    </el-form-item>
    <el-form-item label="昵称" prop="nickName">
      <template v-if="bind">{{ ruleForm.nickName || "暂无~" }}</template>
      <el-input v-else v-model="ruleForm.nickName" placeholder="请输入昵称" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="性别" prop="sex">
      <el-radio-group v-model="ruleForm.sex" :disabled="bind">
        <el-radio :label="1">男</el-radio>
        <el-radio :label="2">女</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="联系电话" prop="phone">
      {{ ruleForm.phone }}
    </el-form-item>
    <el-form-item label="邮箱" prop="email">
      {{ ruleForm.email }}
    </el-form-item>
    <el-form-item label="个性签名" prop="sign">
      <template v-if="bind">{{ ruleForm.sign || "暂无~" }}</template>
      <el-input
          v-else
          v-model="ruleForm.sign"
          :rows="5"
          type="textarea"
          placeholder="请输入个性签名"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-button @click="cancelForm('ruleForm')">取消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">{{ bind ? "绑定" : "创建" }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {bindWincourseUser, registerAndBindWincourseUser} from "@/api/auth/jwt";

export default {
  name: "WincourseUserInfo",
  props: {
    bind: {
      type: Boolean,
      default: false
    },
    winCourseToken: {
      type: String,
      default: ""
    },
    defaultData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      rules: {
        username: [
          {required: true, message: '请输入账号', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请设置密码', trigger: 'blur'},
          {min: 8, max: 20, message: '长度在 8 到 20 个字符', trigger: 'blur'}
        ],
        college: [
          {required: false, message: '请输入学校', trigger: 'blur'},
        ],
        realname: [
          {required: true, message: '请输入真实姓名', trigger: 'blur'},
        ],
        workNo: [{required: true, message: '请输入学/工号', trigger: 'blur'},],
        nickName: [
          {required: false, message: '请输入昵称', trigger: 'blur'},
        ],
        sex: [
          {required: true, message: '请选择性别', trigger: 'blur'},
        ],
      },
      ruleForm: {
        username: '',
        password: ''
      },
    }
  },
  watch: {
    defaultData: {
      immediate: true,
      deep: true,
      handler(val) {
        let info = {
          ...this.ruleForm,
          ...val
        }
        let {realname, nickName} = info
        if (realname == null || realname === "") {
          // 真实姓名为空时，用昵称填充
          info.realname = nickName
        }
        this.ruleForm = info
        this.clearValidate('ruleForm')
      }
    }
  },
  methods: {
    /**
     * 清空表单验证
     * @param formName
     */
    clearValidate(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].clearValidate()
      }
    },
    /**
     * 取消
     */
    cancelForm() {
      this.$emit("cancel")
    },
    /**
     * 提交表单
     * @param formName
     */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 创建/绑定用户
          if (this.bind) {
            this.handleBindUser()
          } else {
            this.handleCreateAndBindUser()
          }
        } else {
          return false;
        }
      });
    },
    /**
     * 绑定用户
     */
    handleBindUser() {
      bindWincourseUser(this.winCourseToken)
          .then(() => {
            this.onBindSuccess()
          })
    },
    /**
     * 创建并绑定用户
     */
    handleCreateAndBindUser() {
      registerAndBindWincourseUser({
        ...this.ruleForm
      })
          .then(() => {
            this.onBindSuccess()
          })
    },
    onBindSuccess() {
      // 抛出绑定成功事件
      this.$emit("bind-success")
    }
  }
}
</script>

